import React from 'react';
import './BillingCycleToggle.css';

/**
 * Two-button Monthly / Yearly switch shared by the public pricing page and the Edit Profile plan picker.
 * Controlled: the parent keeps the value ('MONTHLY' or 'ANNUAL') and receives onChange(newValue).
 */
export default function BillingCycleToggle({ value, onChange, monthlyLabel, yearlyLabel, saveBadge, disabled }) {
  const isYearly = value === 'ANNUAL';

  let monthlyClass = 'billing-toggle__btn';
  let yearlyClass = 'billing-toggle__btn';
  if (isYearly) {
    yearlyClass += ' billing-toggle__btn--active';
  } else {
    monthlyClass += ' billing-toggle__btn--active';
  }

  return (
    <div className="billing-toggle" role="radiogroup">
      <button
        type="button"
        role="radio"
        aria-checked={!isYearly}
        className={monthlyClass}
        disabled={disabled}
        onClick={() => onChange('MONTHLY')}
      >
        {monthlyLabel}
      </button>
      <button
        type="button"
        role="radio"
        aria-checked={isYearly}
        className={yearlyClass}
        disabled={disabled}
        onClick={() => onChange('ANNUAL')}
      >
        {yearlyLabel}
        {saveBadge && <span className="billing-toggle__badge">{saveBadge}</span>}
      </button>
    </div>
  );
}
